export const formatAmount = amount => amount.toLocaleString('FI-fi') + ' €'
